import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { PlusIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import type { Template } from '../lib/types';

export default function Templates() {
  const { data, isLoading } = useQuery({
    queryKey: ['templates'],
    queryFn: () => api.get<{ data: Template[] }>('/templates'),
  });

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-white">Templates</h1>
        <button className="btn-primary">
          <PlusIcon className="w-5 h-5 mr-2" />
          New Template
        </button>
      </div>

      {isLoading ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="card h-48 animate-pulse" />
          ))}
        </div>
      ) : data?.data && data.data.length > 0 ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {data.data.map((template) => (
            <div key={template.id} className="card hover:border-primary-400/30 transition-colors cursor-pointer">
              <div className="flex items-start justify-between mb-4">
                <div className="p-2 bg-primary-400/10 rounded-lg">
                  <DocumentTextIcon className="w-5 h-5 text-primary-400" />
                </div>
                {template.is_system && (
                  <span className="badge-info">System</span>
                )}
              </div>
              <h3 className="font-medium text-white mb-2">{template.name}</h3>
              <p className="text-sm text-gray-400 mb-4 line-clamp-2">{template.subject_template}</p>
              <p className="text-xs text-gray-500">
                Created {new Date(template.created_at).toLocaleDateString()}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div className="card text-center py-16">
          <DocumentTextIcon className="w-16 h-16 mx-auto text-gray-600" />
          <h3 className="mt-4 text-xl font-medium text-white">No templates yet</h3>
          <p className="mt-2 text-gray-400">Create email templates to use in your campaigns</p>
          <button className="btn-primary mt-6">
            <PlusIcon className="w-5 h-5 mr-2" />
            Create Template
          </button>
        </div>
      )}
    </div>
  );
}
